import React from 'react';
import Grid from '@material-ui/core/Grid';
import strings from 'strings';
import { FPButtonMenu } from 'UI/components/molecules';
import InfoLabel from 'UI/components/molecules/InfoLabel';
import { ENTITY_PROFILES_ROUTES_MAP, JobOrderEntity } from 'UI/constants/entityTypes';

import { useStyles } from './DetailsSummary.styled';

export const DetailsSummary = ({
  moreActionsDefinition = [],
  primaryAction = null,
  relatedEntities = [],
  title,
  titleLinkProps = null
}) => {
  const classes = useStyles();

  return (
    <Grid container spacing={2}>
      <Grid item xs={8}>
        {titleLinkProps ? (
          <InfoLabel
            title={JobOrderEntity.singular}
            description={title}
            mode="localLink"
            linkProps={{
              ...(titleLinkProps ?? {}),
              type: 'local'
            }}
          />
        ) : (
          <InfoLabel title={JobOrderEntity.singular} description={title} mode="text" />
        )}
      </Grid>
      <Grid item container xs={4} className={classes.actionButtonsContainer}>
        {primaryAction}
        {moreActionsDefinition.length > 0 && (
          <FPButtonMenu
            title={strings.shared.ui.moreActions}
            isIconButton
            variant="outlinePrimary"
            menuItems={moreActionsDefinition}
          />
        )}
      </Grid>
      <Grid item container xs={12}>
        {relatedEntities.map(item => {
          return (
            <Grid item xs={4} key={item.id}>
              <InfoLabel
                title={item.title}
                description={item.description}
                mode="localLink"
                linkProps={{
                  type: 'local',
                  url: ENTITY_PROFILES_ROUTES_MAP[item.entityType].replace(':id', item.id),
                  target: '_blank'
                }}
              />
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );
};
